(function () {
  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function initSlider(root) {
    var media = root.querySelector('[data-compare-media]');
    var before = root.querySelector('[data-compare-before]');
    var handle = root.querySelector('[data-compare-handle]');
    if (!media || !before || !handle) return;

    var dragging = false;

    function setPosition(percent) {
      percent = clamp(percent, 0, 100);
      before.style.clipPath = 'inset(0 ' + (100 - percent) + '% 0 0)';
      handle.style.left = percent + '%';
      handle.setAttribute('aria-valuenow', Math.round(percent));
    }

    function percentFromClientX(clientX) {
      var rect = media.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    function onPointerMove(event) {
      if (!dragging) return;
      setPosition(percentFromClientX(event.clientX));
    }

    function onPointerUp() {
      dragging = false;
      media.classList.remove('is-dragging');
    }

    function onPointerDown(event) {
      dragging = true;
      media.classList.add('is-dragging');
      setPosition(percentFromClientX(event.clientX));
      handle.focus();
      event.preventDefault();
    }

    media.addEventListener('pointerdown', onPointerDown);
    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', onPointerUp);

    handle.addEventListener('keydown', function (event) {
      var current = parseFloat(handle.style.left);
      if (isNaN(current)) current = 50;
      if (event.key === 'ArrowLeft') {
        setPosition(current - 5);
        event.preventDefault();
      } else if (event.key === 'ArrowRight') {
        setPosition(current + 5);
        event.preventDefault();
      } else if (event.key === 'Home') {
        setPosition(0);
        event.preventDefault();
      } else if (event.key === 'End') {
        setPosition(100);
        event.preventDefault();
      }
    });
  }

  document.querySelectorAll('[data-compare-slider]').forEach(initSlider);
})();
